import { Image } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';

import * as S from './style';

export function AppLoader({ hasLogos = true }) {
  return (
    <S.Loader>
      <S.LoaderBody>
        {hasLogos && <Image name="logoFull" alt="Layout Image" height={32} />}
        <S.LoaderAnimation />
      </S.LoaderBody>
      <S.LoaderFooter>Gifting services powered by 1-800-Flowers.com, Inc.</S.LoaderFooter>
    </S.Loader>
  );
}

AppLoader.propTypes = {
  hasLogos: PropTypes.bool
};
